import axiosInstance from "../api/axiosInstance";

// GET list with pagination and search
export const fetchFacilities = (params) =>
  axiosInstance.get("/admin/facilityList", { params });

// ADD
export const addFacility = (data) =>
  axiosInstance.post("/admin/facilityAdd", data);

// UPDATE
export const updateFacility = (id, data) =>
  axiosInstance.put(`/admin/facilityUpdate/${id}`, data);

// CHANGE STATUS
export const changeFacilityStatus = (id, data) =>
  axiosInstance.patch(`/admin/facilityChangeStatus/${id}`, data);

// DELETE
export const deleteFacility = (id) =>
  axiosInstance.delete(`/admin/facilityDelete/${id}`);

// BULK DELETE
export const bulkDeleteFacilities = (ids) =>
  axiosInstance.post("/admin/facilityBulkDelete", { ids });

// Get By ID
export const getFacilityById = (id) =>
  axiosInstance.get(`/admin/facilityGet/${id}`);
